<template>
  <div class="w12 krw coin-table">
    <div
      class="w12 table-row"
      :class="log.remittanceType == '입금' ? 'deposit' : 'withdraw'"
      v-for="(log, index) in historyList"
      :key="index"
    >
      <div class="w12" flex fjb fic>
        <div class="w12 type-line" flex>
          <div class="w6 type-color">
            {{
              log.remittanceType == "입금"
                ? $t("tradeLog.deposit")
                : $t("tradeLog.withdrawal")
            }}
            ({{ logStatus($t(`tradeLog.LogStatus`), log.status) }})
          </div>
          <div class="w6 ta-r">
            {{ log.amount | formatNumber(0) }} {{ activeCoin.code }}
          </div>
        </div>
        <div class="w12 date-line" flex>
          <div class="w6">{{ log.requestDate }}</div>
          <div class="w6 ta-r">
            수수료 {{ log.fee | formatNumber(0) }} {{ activeCoin.code }}
          </div>
        </div>
        <div class="w12 bold txid mt14 list">
          {{ log.remittanceType == "입금" ? log.inBankName : log.outBankName }}
          {{
            log.remittanceType == "입금"
              ? log.inAccountNumber || "-"
              : log.outAccountNumber || "-"
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Moment from "moment";
export default {
  props: {
    list: {
      type: Array,
      required: true,
    },
    activeCoin: {},
  },
  data() {
    return {
      historyList: [],
      moment: Moment,
    };
  },
  watch: {
    list(newVal, oldVal) {
      this.historyList = newVal;
    },
  },
  methods: {
    logStatus(logString, status) {
      return logString[status];
    },
    setDate(date) {
      let list = date.split(" ");
      list[0] = list[0].split("-").join(".");
      list[0] = list[0].slice(2, list[0].length);

      return list;
    },
  },
};
</script>

<style scoped lang="scss" src="./sendLogList.scss"></style>
